import { render, staticRenderFns } from "./GiftCertificates.vue?vue&type=template&id=7467185d&"
import script from "./GiftCertificates.vue?vue&type=script&lang=js&"
export * from "./GiftCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports